import {
  estimateDateEndPoint,
  submitRMDapi,
} from '../../../utils/api/api-endpoint-dictionary';
import callApi from '../../../utils/api/axios';
import {createAction} from 'redux-actions';

const DEFAULT_STATE = {
  selectedDestination: null,
  selectedBank: {},
  selectedAddress: {},
  selectedReinvestment: {},
  selectedMonths: [],
  selectedDay: [],
  selectedDistributionMethod: {
    type: 'none',
    funds: [],
  },
  taxWithholding: {},
  estimateDate: '',
  existingSet: false,
  isLoaded: true,
  isLoading: false,
  success: null,
  isEdit: false,
  invalidDay: false,
  changesMade: false,
  withholdingChanged: false,
  checked: false,
  isTaxPayerSelected: false,
  isTaxPayerLinkOpened: false,
  getStartedClicked: false,
};

/* Action Types */
export const UPDATE_DESTINATION_TYPE = 'UPDATE_DESTINATION_TYPE';
export const UPDATE_SELECTED_BANK = 'UPDATE_SELECTED_BANK';
export const UPDATE_SELECTED_ADDRESS = 'UPDATE_SELECTED_ADDRESS';
export const UPDATE_SELECTED_REINVESTMENTS = 'UPDATE_SELECTED_REINVESTMENTS';
export const UPDATE_SELECTED_MONTHS = 'UPDATE_SELECTED_MONTHS';
export const UPDATE_SELECTED_DAY = 'UPDATE_SELECTED_DAY';
export const UPDATE_SELECTED_DISTRIBUTION_METHOD_TYPE =
  'UPDATE_SELECTED_DISTRIBUTION_METHOD_TYPE';
export const UPDATE_SELECTED_DISTRIBUTION_METHOD_FUNDS =
  'UPDATE_SELECTED_DISTRIBUTION_METHOD_FUNDS';
export const UPDATE_SELECTED_FREQUENCY = 'UPDATE_SELECTED_FREQUENCY';
export const UPDATE_SELECTED_TAX_WITHHOLDING =
  'UPDATE_SELECTED_TAX_WITHHOLDING';
export const SELECT_FUND = 'SELECT_FUND';
export const DESELECT_FUND = 'DESELECT_FUND';
export const UPDATE_ESTIMATE_DATE = 'UPDATE_ESTIMATE_DATE';
export const UPDATE_WITH_EXISTING = 'UPDATE_WITH_EXISTING';
export const SUBMIT_RMD = 'SUBMIT_RMD';
export const EDIT_EXISTING_RMD = 'EDIT_EXISTING_RMD';
export const UPDATE_CHANGES_MADE = 'UPDATE_CHANGES_MADE';
export const UPDATE_WITHHOLDING_MADE = 'UPDATE_WITHHOLDING_MADE';
export const CLEAR_SHOPPING_CART = 'CLEAR_SHOPPING_CART';
export const UPDATE_CHECKBOX = 'UPDATE_CHECKBOX';
export const UPDATE_DISABLE_CHECKBOX = 'UPDATE_DISABLE_CHECKBOX';
export const RESET_SHOPPING_CART = 'RESET_SHOPPING_CART';
export const SELECTED_PAY_TAXER_WITHHOLDING = 'SELECTED_PAY_TAXER_WITHHOLDING';
export const SET_TAX_PAYER_LINK_OPENED = 'SET_TAX_PAYER_LINK_OPENED';
export const GET_STARTED_CLICKED = 'GET_STARTED_CLICKED';
/* Reducers */
export default function shoppingCart(state = DEFAULT_STATE, { payload, type }) {
  const { selectedDistributionMethod } = state;

  switch (type) {
    case `${UPDATE_DESTINATION_TYPE}`:
      const { destinationType } = payload;
      return {
        ...state,
        selectedDestination: destinationType,
      };
    case `${UPDATE_SELECTED_BANK}`:
      const { bank } = payload;
      return {
        ...state,
        selectedBank: bank,
      };
    case `${UPDATE_SELECTED_ADDRESS}`:
      const { address } = payload;
      return {
        ...state,
        selectedAddress: address,
      };
    case `${UPDATE_SELECTED_MONTHS}`:
      const { monthList } = payload;
      return {
        ...state,
        selectedMonths: monthList,
      };
    case `${UPDATE_SELECTED_DAY}`:
      const { day } = payload;
      return {
        ...state,
        selectedDay: day,
      };
    case `${UPDATE_SELECTED_DISTRIBUTION_METHOD_TYPE}`:
      const { distribution } = payload;
      return {
        ...state,
        selectedDistributionMethod: {
          ...selectedDistributionMethod,
          type: distribution,
        },
      };
    case `${UPDATE_SELECTED_DISTRIBUTION_METHOD_FUNDS}`:
      const { distributionFunds } = payload;
      return {
        ...state,
        selectedDistributionMethod: {
          ...selectedDistributionMethod,
          funds: distributionFunds,
        },
      };
    case `${UPDATE_SELECTED_REINVESTMENTS}`:
      const { fund } = payload;
      return {
        ...state,
        selectedReinvestment: {
          fund,
        },
      };
    case `${UPDATE_SELECTED_FREQUENCY}`:
      const { frequency } = payload;
      return {
        ...state,
        selectedMonths: frequency.months,
        selectedDay: frequency.day,
      };
    case `${UPDATE_SELECTED_TAX_WITHHOLDING}`:
      const { taxWithholding } = payload;
      return {
        ...state,
        taxWithholding: taxWithholding,
      };
    case `${UPDATE_WITH_EXISTING}`:
      return {
        ...state,
        ...payload,
        existingSet: true,
        isEdit: true,
      };
    case `${UPDATE_ESTIMATE_DATE}_FULFILLED`:
      const { systematicsSelections } = payload.data;
      return {
        ...state,
        estimateDate: systematicsSelections[0].startDate,
      };
    case `${UPDATE_ESTIMATE_DATE}_REJECTED`:
      return {
        ...state,
        estimateDate: '',
      };
    case `${SUBMIT_RMD}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${SUBMIT_RMD}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        success: true,
      };

    case `${SUBMIT_RMD}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case `${EDIT_EXISTING_RMD}`:
      return {
        ...state,
        isEdit: false,
      };
    case `${UPDATE_CHANGES_MADE}`:
      return {
        ...state,
        changesMade: true,
      };
    case `${UPDATE_WITHHOLDING_MADE}`:
      const { withholdingChanged = true } = payload;
      return {
        ...state,
        withholdingChanged,
      };
    case `${CLEAR_SHOPPING_CART}`:
      return DEFAULT_STATE;
    case `${UPDATE_CHECKBOX}`:
      return {
        ...state,
        checked: payload,
      };
    case `${UPDATE_DISABLE_CHECKBOX}`:
      return {
        ...state,
        disableAlerts: payload,
      };
    case `${RESET_SHOPPING_CART}`:
      return {
        selectedDestination: null,
        selectedBank: {},
        selectedAddress: {},
        selectedReinvestment: {},
        selectedMonths: [],
        selectedDay: [],
        selectedDistributionMethod: {
          type: 'none',
          funds: [],
        },
        taxWithholding: {},
        estimateDate: '',
        existingSet: false,
        isLoaded: true,
        isLoading: false,
        success: null,
        isEdit: false,
        changesMade: false,
        checked: false,
      };
    case `${SELECTED_PAY_TAXER_WITHHOLDING}`:
      return {
        ...state,
        isTaxPayerSelected: payload,
      };
    case `${SET_TAX_PAYER_LINK_OPENED}`:
      return {
        ...state,
        isTaxPayerLinkOpened: true,
      };
    case `${GET_STARTED_CLICKED}`:
      return {
        ...state,
        getStartedClicked: true,
      };
    default:
      return state;
  }
}

/* Actions */

export const updateDestinationType = (destinationType) => ({
  type: UPDATE_DESTINATION_TYPE,
  payload: { destinationType },
});

export const updateSelectedBank = (bank) => ({
  type: UPDATE_SELECTED_BANK,
  payload: { bank },
});

export const updateSelectedAddress = (address) => ({
  type: UPDATE_SELECTED_ADDRESS,
  payload: { address },
});

export const updateSelectedReinvestment = (fund) => ({
  type: UPDATE_SELECTED_REINVESTMENTS,
  payload: { fund },
});

export const updateSelectedMonths = (monthList) => ({
  type: UPDATE_SELECTED_MONTHS,
  payload: { monthList },
});

export const updateSelectedDay = (day) => ({
  type: UPDATE_SELECTED_DAY,
  payload: { day },
});

export const updateSelectedDistributionType = (distribution) => ({
  type: UPDATE_SELECTED_DISTRIBUTION_METHOD_TYPE,
  payload: { distribution },
});

export const updateSelectedDistributionFunds = (distributionFunds) => ({
  type: UPDATE_SELECTED_DISTRIBUTION_METHOD_FUNDS,
  payload: { distributionFunds },
});

export const updateSelectedFrequency = (frequency) => ({
  type: UPDATE_SELECTED_FREQUENCY,
  payload: { frequency },
});

export const updateSelectedTaxWithholding = (taxWithholding) => ({
  type: UPDATE_SELECTED_TAX_WITHHOLDING,
  payload: { taxWithholding },
});

export const getEstimatedDate = (payload) => {
  return (dispatch) => {
    const action = createAction(UPDATE_ESTIMATE_DATE)(
      callApi(
        estimateDateEndPoint,
        { method: 'post', requestBody: payload },
        false,
        process.env.NODE_ENV === 'development'
      )
    );
    try {
      return dispatch(action);
    } catch (e) {
      console.error(e);
    }
  };
};

export const submitNewRMD = (payload) => {
  return (dispatch) => {
    const action = createAction(SUBMIT_RMD)(
      callApi(
        submitRMDapi,
        { method: 'post', requestBody: payload },
        false,
        process.env.NODE_ENV === 'development'
      )
    );
    try {
      return dispatch(action);
    } catch (e) {
      console.error(e);
    }
  };
};

export const resetShoppingCart = () => ({
  type: RESET_SHOPPING_CART,
  payload: {},
});

export const editExisting = (payload) => {
  return (dispatch) => {
    const action = createAction(SUBMIT_RMD)(
      callApi(
        submitRMDapi,
        { method: 'put', requestBody: payload },
        false,
        process.env.NODE_ENV === 'development'
      )
    );
    try {
      return dispatch(action)
    } catch (e) {
      console.error(e);
    }
  };
};

export const updateShoppingCarWithExisting = (payload) => ({
  type: UPDATE_WITH_EXISTING,
  payload: payload,
});

export const editExistingRMD = () => ({
  type: EDIT_EXISTING_RMD,
  payload: {},
});

export const updateChangesMade = () => ({
  type: UPDATE_CHANGES_MADE,
  payload: {},
});

export const updateWithholdingMade = (payload = {}) => ({
  type: UPDATE_WITHHOLDING_MADE,
  payload: {},
});

export const clearShoppingCart = () => ({
  type: CLEAR_SHOPPING_CART,
  payload: {},
});

export function selectFund(agreementID, fund, BPID) {
  return (dispatch) => {
    dispatch(createAction(SELECT_FUND, { agreementID, fund, BPID })).catch((error) => console.error(error));
  };
}
